import styled from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';
import { CheckboxInput } from '../inputs/CheckboxInput.js';
import { CHECKBOX_SIZE_REM, INPUT_DISABLED_DATA_ATTRIBUTE } from '../inputs/InputCommon.js';
import { getThemeVariantColor } from '../styles/stylePropTypes.js';
import { CheckboxField } from './CheckboxField.js';

/**
 * Styled Components
 */ const ToggleCheckbox = styled(CheckboxField)`
  &[${CheckboxInput.dataId}] {
    width: ${CHECKBOX_SIZE_REM * 2}rem;
  }

  & [${CheckboxInput.dataId}-custom-input] {
    background-color: ${COLOR_PALETTE.slateGrey40};
    border-color: ${COLOR_PALETTE.slateGrey40};
    border-radius: ${CHECKBOX_SIZE_REM}rem;
    border-width: 2px;
    width: ${CHECKBOX_SIZE_REM * 2}rem;
  }

  & [${CheckboxInput.dataId}-input]:checked ~ [${CheckboxInput.dataId}-custom-input]::after {
    border-color: ${getThemeVariantColor("context")};
    top: 0;
    transform: translateX(107%);
  }

  & [${CheckboxInput.dataId}-custom-input]::after {
    content: '';
    position: absolute;
    border: 2px solid ${COLOR_PALETTE.slateGrey40};
    border-color: inherit;
    height: ${CHECKBOX_SIZE_REM}rem;
    width: ${CHECKBOX_SIZE_REM}rem;
    left: -2px; /* offset from border */
    top: -2px; /* offset from border */
    background: ${COLOR_PALETTE.white};
    border-radius: 50%;
    /* animate toggle on/off */
    transform: translateX(0%);
    transition: transform 0.15s linear;
  }

  &[${INPUT_DISABLED_DATA_ATTRIBUTE}] [${CheckboxInput.dataId}-custom-input] {
    background-color: ${COLOR_PALETTE.slateGrey20};
    border-color: ${COLOR_PALETTE.slateGrey20};
  }

  &[${INPUT_DISABLED_DATA_ATTRIBUTE}] [${CheckboxInput.dataId}-input] ~ [${CheckboxInput.dataId}-custom-input]::after {
    border-color: ${COLOR_PALETTE.slateGrey20};
  }
`;
/**
 * Toggle Input with Formik Field bindings.
 *
 * @example
 * <ToggleField name="chekkkers" />
 */ const ToggleField = ToggleCheckbox;
ToggleField.dataId = "data-hpy-web-toggle-field";
ToggleField.displayName = "ToggleField";

export { ToggleField };
